import {createSelector} from 'reselect';

import {ConfigState} from '@common/types/stores/configStore.types';

const createConfigSelector = createSelector.withTypes<ConfigState>();

export const selectIsLoading = createConfigSelector([state => state], state => state.isLoading);
export const selectIsConfigLoaded = createConfigSelector([state => state], state => !!state.endpoints && !!state.upload);
